import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import VMask from '@/components/common/VMask';
import RefundTable from './refund-table';
import RefundProjectDetail from './refund-project-detail';
export default {
  name: 'refund-order-detail',
  components: {
    RefundTable: RefundTable,
    'v-mask': VMask,
    RefundProjectDetail: RefundProjectDetail
  },
  props: {
    performanceId: {
      type: Number
    },
    showId: {
      type: Number
    },
    useTime: {
      type: Number
    },
    onClose: {
      type: Function,
      default: function _default() {}
    },
    isNewPage: {
      type: Boolean
    },
    batchRefundRuleDetails: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      isShowProjectDetail: false,
      isShowModalTop: false,
      isShowModalBottom: true,
      orderRefundData: []
    };
  },
  computed: {},
  watch: {},
  mounted: function mounted() {
    this.$refs.projectRefundBox && this.$refs.projectRefundBox.addEventListener('scroll', this.scroll);
    if (this.batchRefundRuleDetails.length) {
      this.getOrderRefundRule();
    }
  },
  destroyed: function destroyed() {
    this.$refs.projectRefundBox && this.$refs.projectRefundBox.removeEventListener('scroll', this.scroll);
  },
  methods: {
    getOrderRefundRule: function getOrderRefundRule() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var data, newData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = _this.batchRefundRuleDetails;
              newData = [];
              data.map(function (item) {
                var refundRuleDetails = item.showRefundRuleDetails.map(function (it) {
                  return Object.assign({}, it, {
                    showBuyTag: it.refundRules.some(function (rule) {
                      return rule.currentUse;
                    }),
                    refundRules: it.refundRules.filter(function (rule) {
                      return rule.currentUse;
                    }) || []
                  });
                });
                var availableRules = refundRuleDetails.find(function (it) {
                  return it.showBuyTag;
                });
                if (availableRules) {
                  newData.push(Object.assign({}, item, {
                    showRefundRuleDetails: refundRuleDetails
                  }));
                }
              });
              _this.orderRefundData = newData;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onShowProjectRefundRule: function onShowProjectRefundRule() {
      // 添加埋点
      this.isShowProjectDetail = true;
      window.seedAction({
        bid: 'b_movie_6c3fb93u_mc',
        cid: 'c_l1Ub4',
        evt: 'click',
        custom: {
          performance_id: this.performanceId
        }
      });
    },
    handleClose: function handleClose() {
      this.isShowProjectDetail = false;
      this.onClose();
    },
    handlePre: function handlePre() {
      this.isShowProjectDetail = false;
    },
    scroll: function scroll() {
      var _this$$refs$projectRe = this.$refs.projectRefundBox,
        scrollTop = _this$$refs$projectRe.scrollTop,
        clientHeight = _this$$refs$projectRe.clientHeight,
        scrollHeight = _this$$refs$projectRe.scrollHeight;
      if (scrollTop > 20) {
        this.isShowModalTop = true;
      } else {
        this.isShowModalTop = false;
      }
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.isShowModalBottom = false;
      } else {
        this.isShowModalBottom = true;
      }
    }
  }
};